import { getData } from "./Http/api";

// Marcadores que el usuario puede usar en el texto de un Mensaje. Al contactar por
// WhatsApp se reemplazan por los datos del caso (ver armarMensaje).
export const MARCADORES_MENSAJE = [
  { marcador: "{contribuyente}", descripcion: "Nombre del contribuyente (sujeto)" },
  { marcador: "{gestor}", descripcion: "Usuario gestor asignado al caso" },
  { marcador: "{organismo}", descripcion: "Organismo del caso" },
  { marcador: "{objetos}", descripcion: "Objetos del caso (ej. dominios, partidas)" },
];

export const fetchMensajes = async () => {
  try {
    const response = await getData("/MensajeListar");
    return (response?.value || []).map((item) => ({
      idMensaje: item.idMensaje,
      tipoMensaje: item.tipoMensaje,
      texto: item.texto,
    }));
  } catch (ex) {
    console.error("Error cargando Mensajes:", ex);
    return [];
  }
};

// Reemplaza los marcadores del texto por los datos recibidos. Un dato vacío deja el
// marcador en blanco en vez de mostrar "{gestor}" crudo al contribuyente.
export const armarMensaje = (texto, { contribuyente, gestor, organismo, objetos } = {}) =>
  (texto || "")
    .replace(/\{contribuyente\}/gi, contribuyente || "")
    .replace(/\{gestor\}/gi, gestor || "")
    .replace(/\{organismo\}/gi, organismo || "")
    .replace(/\{objetos\}/gi, objetos || "");
